module.exports = __webpack_public_path__ + "img/invitation_code_icon.f1fd22ca.svg";